import { DISCLAIMER_VERSION, REGULATORY_BASELINE, SOURCE_LIST, formatDate } from "@aigov/domain";
import { DisclaimerText } from "./Disclaimer";

export function SourcesView() {
  return (
    <div className="stack">
    <section className="panel notice" id="notice">
      <DisclaimerText />
      <p className="muted small" style={{ marginBottom: 0 }}>Notice version {DISCLAIMER_VERSION}.</p>
    </section>
    <section className="panel">
      <h2>Sources and regulatory baseline</h2>
      <p className="muted small" style={{ maxWidth: "80ch" }}>
        Dates and scope rules in the applicability engine were checked against these sources on {formatDate(REGULATORY_BASELINE)}.
        Items marked "verify detail" rely on working knowledge; check them against the official text before relying on them in client advice.
      </p>
      <div className="scroll"><table>
        <thead><tr><th>Area</th><th>Source</th><th>Used for</th></tr></thead>
        <tbody>{SOURCE_LIST.map((s) => (
          <tr key={s.key}><td><span className="chip">{s.area}</span></td>
            <td><a href={s.url} target="_blank" rel="noopener noreferrer">{s.title}</a></td>
            <td className="small">{s.usedFor}</td></tr>))}
        </tbody>
      </table></div>
      <div className="note" style={{ marginTop: 14 }}>ISO/IEC standards are copyrighted and licensed per user. This tool stores clause numbers and paraphrased control wording only. Each client needs its own copies, or you need a licence from ISO or a national body, before any screen shows standard text.</div>
    </section>
    </div>
  );
}
